// extracted by mini-css-extract-plugin
export default {"container":"sQ-z","title":"tQ-z","link":"uQ-z"};